/* global Sys, Core */
Sys.ns("Core");

/**
 * Postman module enables cross-origin communication.
 *
 * Two types of cross-origin communication is used:
 *
 * - NetEntExtend API (with restricted functionality) needs to communicate with the iframe containing it (isInIframe)
 * - NetEntExtend Plugin Script needs to communicate with the plugin iframe the game contains if operator provides a plugin
 *
 * Those two modes should not be used in the same time. Read more on Core.NetEntExtend about the API.
 *
 * @class Core.Postman
 * @extends Core.Module
 */
Core.Postman = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.Postman.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    getStateChanges: function() {
        return {
            setupGame: {
                waitEvents: [
                    "notify:postman.ready"
                ]
            }
        };
    },

    /**
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            controller: Core.PostmanController
        };
    }
};

Core.Postman = Sys.extend(Core.Module, Core.Postman, "Core.Postman");
